export default __webpack_public_path__ + "static/media/cover_big.2a457ba4.jpg";